import {useState,useEffect}from"react";
import {Link} from "react-router-dom";
import ItemValueEdit from '../../item/itemValueEdit';
import ItemCustomFieldEdit from '../../item/itemCustomFieldEdit';
import ItemNoteEdit from '../../item/itemNoteEdit';
import ItemSettingEdit from '../../item/itemSettingEdit';
import Select from "react-select";
import {all_routes} from "../../../../../feature-module/router/all_routes";
import ImageUploading from 'react-images-uploading';
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Str,Status_Type,Log} from "biz9-utility";
import {Remote} from "biz9-remote";
import {Image_Type,Image_Table,Image_Field,Image_Service} from "biz9-image";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";
import {Store_Field} from "biz9-store";
import {Field,Message,Title,Config} from "../../../../../constant";
import {App,Data,Dashboard,Image,Style,Toast_Message} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
const Dashboard_App_Custom_Field_Edit = () => {
    const query = UrlQuery();
    const [val_id,setValId] = useState(query.get('id'));
    const [val_sub_page_title,setValSubPageTitle] =  useState("");
    const [field_values,setFieldValues] = useState([]);
    const [image_primary,setImagePrimary] = useState([]);
    const [val_title,setValTitle] = useState("");
    const [val_description,setValDescription] = useState("");
    const [val_category_type,setValCategoryType] = useState(null);
    const [category_types,setCategoryTypes] = useState([]);
    const [item,setItem] = useState(Data_Logic.get(Portal_Table.CUSTOM_FIELD,val_id));
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(val_id){
            get_data();
            }
            },[val_id]);
    async function get_data() {
        let option = {};
        let [response,data] = await Portal_Remote_CMS.get(App.get_url(Portal_Url.CMS_GET),Portal_Table.CUSTOM_FIELD,val_id,{category:Title.CUSTOM_FIELD},option);
        bind_page(data[Portal_Type.ITEM]);
        bind_field(data[Portal_Type.ITEM]);
        bind_field_value(data[Portal_Type.ITEM]);
        bind_items(data);
        Toast_Message.dismiss();
    };
    async function bind_page(item) {
        setValSubPageTitle(item.title);
    };
    async function bind_field(data) {
        setItem(Data_Logic.clean(data));
        setValTitle(data.title);
        setValDescription(data.description);
    };
    async function bind_field_value(item) {
        setFieldValues(Data.bind_field_values(item));
    };
    async function bind_items(data){
        let category_types = Data.get_type_categorys(Data.get_tables(),{blank:true});
        setCategoryTypes(category_types);
        setValCategoryType(category_types.find(option => option.value === data.category_type));
    };
    async function post_field(item,field,value,option){
        if(!value){
            value = '';
        }
        if(field == Portal_Field.TITLE && !Str.check_is_null(item[Portal_Field.TITLE])){
            item[Portal_Field.TITLE_URL] = Str.get_title_url(value);
        }
        option = option ? option : {required:false,success_message:''};
        if(value.trim() === '' && option.required) {
            Toast_Message.error(Str.get_title(field) + " " +Message.INPUT_REQUIRED);
        }else{
            Toast_Message.loading(Message.SAVING);
            item[field] = value;
            setItem(item);
            bind_page(item);
            let option_post = {overwrite:true,clean:true};
            let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.CUSTOM_FIELD,item,option_post);
            if(!option.success_message){
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(option.success_message);
            }
        }
    };
    const handle_submit = (event) =>{
        event.preventDefault();
    };
    const updateValTitle = (event) => {
           setValTitle(event.target.value);
    };
    const updateValCategoryType = (selectedOption) => {
        setValCategoryType(selectedOption);
        post_field(item,Field.CATEGORY_TYPE,selectedOption.value,{});
    };
    const updateValDescription = (event) => {
        setValDescription(event.target.value);
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="settings-info bg-white">
            <div className="settings-page-lists">
            <ul className="settings-head nav nav-tabs" role="tablist">
            <li className="nav-item" role="presentation">
            <Link to="#" className="nav-link active" data-bs-toggle="tab" data-bs-target="#tab_general"
            aria-selected="false" role="tab" tabIndex={-1}>
            General
            </Link>
            </li>
            <li className="nav-item" role="presentation">
            <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_value" aria-selected="false"
            role="tab" tabIndex={-1}>
            Values
            </Link>
            </li>
            <li className="nav-item" role="presentation">
            <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_setting" aria-selected="false" role="tab"
            tabIndex={-1}>
            Settings
            </Link>
            </li>
            </ul>
            </div>
            <ul className="nav nav-tabs nav-tabs-bottom mb-4">
            <li className="nav-item">
            <Link to={all_routes.dashboard_app_custom_field} className="nav-link" >
            {"<- Back"}
    </Link>
        </li>
        </ul>
        <div className="tab-content">
        {/* General Tab  */}
    <div className="tab-pane fade show active" id="tab_general" role="tabpanel">
        <div className="settings-card">
        <div className="settings-card-head bg-light">
        <h4>General</h4>
        </div>
        <form onSubmit={handle_submit}>
        <div className="settings-card-body">
        <div className="row">
        <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        {" "}
    Title{" "}
    <span className="text-primary">*</span>
        </label>
        <input value={val_title} onChange={updateValTitle} type="text" className="form-control" onBlur={() => post_field(item,Portal_Field.TITLE,val_title,{required:true})} />
        </div>
        </div>
        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        Category Type
        </label>
        <Select classNamePrefix="react-select" className="select" styles={Style.customStyles} options={category_types} value={val_category_type} onChange={updateValCategoryType} />
        </div>
        </div>
        <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        {" "}
    Description{" "}
    </label>
        <input value={val_description} onChange={updateValDescription} type="text" className="form-control"  onBlur={() => post_field(item,Field.DESCRIPTION,val_description,{})} />
        </div>
        </div>
        </div>
        </div>
        </form>
        </div>
        </div>
        {/* /General Tab  */}
    {/* Value Tab */}
    <div className="tab-pane fade" id="tab_value" role="tabpanel">
        <ItemValueEdit field_values={field_values} item={item} onFieldValuesUpdate={setFieldValues} onItemUpdate={setItem} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
        </div>
        {/* Value Tab */}
    {/* Setting Tab */}
    <div className="tab-pane fade" id="tab_setting" role="tabpanel">
        <ItemSettingEdit item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
        </div>
        {/* Setting Tab */}
    </div>
    {/* /Page Content */}
    </div>
        </div>
        </div>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        </div>
        {/* /Page Content */}
    </>
        );
};
export default Dashboard_App_Custom_Field_Edit;
